module.exports = __webpack_public_path__ + "img/documents.dcdff48f.svg";